import React, { useMemo, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import Button from '../../../components/Button/Button'
import Card from '../../../components/Card/Card'
import ComboInput from '../../../components/ComboInput'
import Message from '../../../components/Message/Message'
import Notification from '../../../components/Notification/Notification'
import { WORLD_CUP_LEADERBOARD, WORLD_CUP_TEAMS } from '../../../graphql/queries'
import { SET_WORLD_CHAMPION } from '../../../graphql/mutations'
import useNotification from '../../../hooks/useNotification'

export default function WorldCupChampionAdmin() {
  const { showNotification, notificationProps } = useNotification()
  const [worldChampion, setWorldChampion] = useState('')

  const { data: teamsData } = useQuery(WORLD_CUP_TEAMS, { fetchPolicy: 'cache-and-network' })
  const { refetch: refetchLeaderboard } = useQuery(WORLD_CUP_LEADERBOARD, { skip: true })

  const teamOptions = useMemo(() => {
    const savedTeams = teamsData?.worldCupTeams?.teams
    const list = Array.isArray(savedTeams) ? savedTeams.map((t) => t.name).filter(Boolean) : []
    const val = (worldChampion || '').trim()
    if (val && !list.includes(val)) list.unshift(val)
    return list.sort((a, b) => a.localeCompare(b, 'da-DK'))
  }, [teamsData, worldChampion])

  const [setChampion] = useMutation(SET_WORLD_CHAMPION, {
    onCompleted: async () => {
      showNotification('Verdensmester sat og bonuspoint beregnet', 'success')
      await refetchLeaderboard()
    },
    onError: (e) => showNotification(e.message || 'Kunne ikke sætte verdensmester', 'error'),
  })

  return (
    <>
      <Notification {...notificationProps} />
      <Card className="worldcup-admin-card" hover={false}>
        <h3>Sæt verdensmester</h3>
        <p className="worldcup-admin-help">
          Vælg det hold der vandt VM. Bonuspoint beregnes for alle med det rigtige verdensmester-gæt.
        </p>
        {teamOptions.length === 0 ? (
          <Message type="warning">Gem VM-hold først, så du kan vælge verdensmester.</Message>
        ) : null}
        <div className="worldcup-admin-inline">
          <div className="worldcup-admin-field worldcup-admin-field--grow">
            <span className="worldcup-admin-label">Verdensmester</span>
            <ComboInput
              id="wc-champion"
              value={worldChampion}
              options={teamOptions}
              placeholder="Vælg verdensmester"
              ariaLabel="Verdensmester"
              onChange={setWorldChampion}
            />
          </div>
          <Button title="Gem verdensmester" onClick={() => setChampion({ variables: { championTeam: worldChampion } })} />
        </div>
      </Card>
    </>
  )
}
